import React from 'react';

import { VpCTATemp } from 'ha/components/ValuePropositions/VpCTATemp';
import { ValuePropositionTypes } from '@ha/contentful';
import { useLocation } from 'react-router-dom';
import { VpChecklist } from './VpChecklist';
import { VpDouble } from './VpDouble';
import { VpTripple } from './VpTripple';
import { VpDefault } from './VpDefault';
import { VpLarge } from './VpLarge';
import { VpLargeWithLinks } from './VpLargeWithLinks';
import { VpTabs } from './VpTabs';

import { ValueProposition } from './types';

interface Props {
  vp: ValueProposition;
}

export const ValuePropositionSwitch: React.FC<Props> = ({ vp }) => {
  const { pathname } = useLocation();
  switch (vp.type) {
    case ValuePropositionTypes.DEFAULT: {
      if (
        vp?.description.toLowerCase() === 'remove by code' &&
        pathname?.includes('lease-protection')
      )
        return <VpCTATemp valueProposition={vp} />;
      return <VpDefault valueProposition={vp} />;
    }
    case ValuePropositionTypes.CHECKLIST:
      return (
        <VpChecklist
          valuePropositions={vp.valuePropositions}
          title={vp.title}
        />
      );
    case ValuePropositionTypes.DOUBLE:
      return (
        <VpDouble valuePropositions={vp.valuePropositions} title={vp.title} />
      );
    case ValuePropositionTypes.TRIPPLE:
      return <VpTripple valuePropositions={vp.valuePropositions} />;
    case ValuePropositionTypes.LARGE:
      return <VpLarge valueProposition={vp} />;
    case ValuePropositionTypes.LARGE_WITH_LINKS:
      return <VpLargeWithLinks valueProposition={vp} />;
    case ValuePropositionTypes.TABS:
      return <VpTabs valueProposition={vp} />;
    default:
      return null;
  }
};
